export const stepperEsLocale = {
  'checkout.stepper.title1': 'Información del cliente',
  'checkout.stepper.title2': 'Método de pago',
} as const;

export const stepperEnLocale = {
  'checkout.stepper.title1': 'Client information',
  'checkout.stepper.title2': 'Payment method',
} as const;
